/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskWebhoseOverviewEntry } from './ExecRiskWebhoseOverviewEntry';
import {
    ExecRiskWebhoseOverviewEntryFromJSON,
    ExecRiskWebhoseOverviewEntryFromJSONTyped,
    ExecRiskWebhoseOverviewEntryToJSON,
} from './ExecRiskWebhoseOverviewEntry';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedWebhoseResponse
 */
export interface ExecRiskPaginatedWebhoseResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedWebhoseResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskWebhoseOverviewEntry>}
     * @memberof ExecRiskPaginatedWebhoseResponse
     */
    results: Array<ExecRiskWebhoseOverviewEntry>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedWebhoseResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedWebhoseResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedWebhoseResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedWebhoseResponse interface.
 */
export function instanceOfExecRiskPaginatedWebhoseResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedWebhoseResponseFromJSON(json: any): ExecRiskPaginatedWebhoseResponse {
    return ExecRiskPaginatedWebhoseResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedWebhoseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedWebhoseResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskWebhoseOverviewEntryFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedWebhoseResponseToJSON(value?: ExecRiskPaginatedWebhoseResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskWebhoseOverviewEntryToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

